import {
  BaseConfigurationModal,
  BaseConfigurationRow,
} from "./BaseConfiguration";
import { OAuthModal, OAuthRow } from "./OAuth";
import { IdentityMatchingRow } from "@/destinations/configs/shared/IdentityMatchingRow/IdentityMatchingRow";

const BASE_CONFIGURATION = "BASE_CONFIGURATION";
const OAUTH = "OAUTH";
const IDENTITY_MATCHING = "IDENTITY_MATCHING";

const Rows = {
  [BASE_CONFIGURATION]: BaseConfigurationRow,
  [OAUTH]: OAuthRow,
  [IDENTITY_MATCHING]: IdentityMatchingRow,
};

const Modals = {
  [BASE_CONFIGURATION]: BaseConfigurationModal,
  [OAUTH]: OAuthModal,
};

const RowOrder = [BASE_CONFIGURATION, OAUTH, IDENTITY_MATCHING];

const config = {
  Rows,
  RowOrder,
  Modals,
};

export default config;
